// React and Libraries
import React from "react";
import { v4 as uuidv4 } from 'uuid';

// Helpers & Constants
import Helpers from "@Apis/helpers";
import Constants from '@Apis/constants';

// Ant Design
import { Popconfirm, Drawer, Select, Tooltip, Alert, notification, Popover, Button } from 'antd';
import { LoadingOutlined, EditOutlined, UserOutlined, CaretRightOutlined, EditFilled, CheckOutlined } from '@ant-design/icons';
import SelectCustomStatus from "@Components/Common/SelectCustomStatus";

// UI Library
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

function ViewDCLeftSectionHeader ({
  state,
  props,
  getRecipient,
  updateState,
}) {

  const { selectedDC, downloadDocument, user, deleteDC, deleteDCLoading, history, callback, updateDeliveryChallanStatus, getDCById, isQuickView, selectedDCId, } = props;

  const { cancellationReason, currentUpdate, } = state;

  const addAlpha = (color, opacity) => {
    // coerce values so ti is between 0 and 1.
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
  }

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text text={selectedDC?.dc_number} className="view-document__title-number" />
        <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedDC?.status).color }}>
          {selectedDC?.status?.replaceAll('_', ' ')}
        </div>
        {getRecipient()?.type && (
          <div
            className="view-document__title-status"
            style={{ backgroundColor: Helpers.getStatusColor('CANCELLED').color }}
          >
            {getRecipient()?.type}
          </div>
        )}
      </div>

      {!isQuickView && (
        <div className="view-document__title-actions">
          <div className="action-buttons">
            {selectedDC?.status === 'DRAFT' && (<H3Text
              className="action-button hide__in-mobile"
              onClick={() => updateState({ showDCDrawer: true })}
              text={(
                <EditOutlined />
              )}
            />)}
            <H3Text
              text={
                <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
              }
              onClick={() => downloadDocument({
                url: `${Constants.DC}/download?dc_id=${selectedDC?.delivery_challan_id}&tenant_id=${selectedDC?.source_tenant_department_info?.tenant_id ? selectedDC?.source_tenant_department_info?.tenant_id : selectedDC?.tenant_configuration?.tenant_id}&type=pdf`,
                document_type: 'DELIVERY_CHALLAN',
                document_number: selectedDC?.dc_number,
                key: uuidv4(),
              })}
              className="action-button"
            />
          </div>
          {selectedDC?.tenant_configuration?.tenant_id === user?.tenant_info?.tenant_id && (
            <div className="action-buttons">
              {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
                Helpers.permissionTypes.DELETE, user) && (
                <Popconfirm
                  placement="topRight"
                  title="Are you sure you want to delete the Delivery Challan?"
                  onConfirm={() => {
                    deleteDC({
                      tenant_id: user?.tenant_info?.tenant_id,
                      challan_id: selectedDC.delivery_challan_id,
                    }, () => {
                      if (selectedDCId) {
                        callback();
                      } else {
                        history.push('/inventory/delivery-challan');
                      }
                    });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <H3Text
                    text={(
                      <div>
                        {deleteDCLoading ? <LoadingOutlined /> : (
                          <span>Delete</span>
                        )}
                      </div>
                    )}
                    className="action-button action-button-big"
                  />
                </Popconfirm>
              )}
              {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
                Helpers.permissionTypes.DELETE, user) && selectedDC?.status !== 'VOID' && (
                <Popover
                  placement="topRight"
                  title="Are you sure you want to cancel?"
                  content={(
                    <React.Fragment>
                      <H3FormInput
                        name="cancellation reason"
                        type="text"
                        containerClassName="orgInputContainer create__right-input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => updateState({ cancellationReason: event.target.value })}
                        value={cancellationReason}
                        label="Reason"
                        maxlength="100"
                        required
                        showError={currentUpdate === 'VOID' && !cancellationReason}
                      />
                      <div
                        className="view-document__cancellation-buttons"
                      >
                        <Button
                          // disabled={selectedInvoice?.credit_notes?.length || selectedInvoice?.e_invoice_status === 'PUSHED'}
                          onClick={() => {
                            updateState({ currentUpdate: 'VOID' });
                            if (cancellationReason) {
                              updateDeliveryChallanStatus({
                                status: 'VOID',
                                delivery_challan_id: selectedDC?.delivery_challan_id,
                                cancellation_reason: cancellationReason,
                              }, () => {
                                if (callback) {
                                  callback();
                                } else {
                                  getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id);
                                  updateState({ cancellationPop: false });
                                }
                              });
                            }
                          }}
                          type="primary"
                          size="small"
                        >
                          Cancel
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                  trigger="click"
                >
                  <H3Text
                    text={(
                      <div>
                        <span>Cancel</span>
                      </div>
                    )}
                    className="action-button action-button-big"
                  />
                </Popover>
              )}
              {Helpers.getPermission(Helpers.permissionEntities.E_WAY_BILL, Helpers.permissionTypes.UPDATE, user) && !selectedDC?.e_way_bills?.filter((rec) => rec?.status === 'GENERATED')?.length && user?.tenant_info?.is_e_way_bill_enabled && selectedDC?.sales_order_info?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && selectedDC?.status === 'CONFIRMED' && (
              <div style={{ width: '100px', borderRight: '1px solid rgba(45, 124, 247, 0.5)' }}>
                <H3Text
                  text="+ e-Way Bill"
                  className="action-button action-button-big"
                  onClick={() => updateState({ showEWaybillFormDrawer: true })}
                />
              </div> 
              )}
              {user?.tenant_info?.sales_config?.sub_modules?.invoice?.is_active && Helpers.getPermission(Helpers.permissionEntities.INVOICE,
                Helpers.permissionTypes.CREATE, user) && selectedDC?.invoice_id === null && selectedDC?.stock_transfer_id === null
                && (selectedDC?.adhoc_dc_customer_id || selectedDC?.customer_id) && selectedDC?.sales_order_info?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && selectedDC?.status === 'CONFIRMED' && (
                <div style={{ width: '80px' }}>
                  <H3Text
                    text="+ Invoice"
                    className="action-button action-button-big"
                    onClick={() => updateState({ showNewInvoiceForm: true })}
                  />
                </div>  
                )}
                {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
                  Helpers.permissionTypes.UPDATE, user) && selectedDC?.custom_status_info?.type !== 'VOID' && (
                  <SelectCustomStatus
                    selectedCustomStatus={selectedDC?.custom_status_id}
                    hideTitle
                    tenantId={selectedDC?.tenant_id}
                    posibleStatuses={[selectedDC?.custom_status_info, ...selectedDC?.possible_status ?? []]}
                    onChange={(value) => {
                      updateDeliveryChallanStatus({
                        status: value?.type,
                        secondary_status: value?.status_name,
                        delivery_challan_id: selectedDC?.delivery_challan_id,
                        custom_status_id: value?.custom_status_id,
                      }, () => {
                        getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id);
                      });
                    }}
                    disabled={['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedDC?.custom_status_info?.type)}
                    customStyle={{
                      color: selectedDC?.custom_status_info?.color_code,
                      backgroundColor: addAlpha(selectedDC?.custom_status_info?.color_code, 1),
                      height: '35px',
                    }}
                  />
                )}
            </div>
          )}
        </div>
      )}
    </div>
  )
};

export default ViewDCLeftSectionHeader;